import {
  Cloud,
  CloudNight,
  Cloudy,
  Moon,
  PartlyCloudyNight,
  PartlyCloudy,
  RainScatteredNight,
  RainScattered,
  Rain,
  Sun,
  Thunderstorm,
  WindyStrong,
  Snow
} from 'icons'
export const getWeatherIcon = weatherIcon => {
  switch (weatherIcon) {
    case '01d':
      return Sun
    case '01n':
      return Moon
    case '02d':
      return PartlyCloudy
    case '02n':
      return PartlyCloudyNight
    case '03d':
      return Cloud
    case '03n':
      return CloudNight
    case '04d':
    case '04n':
      return Cloudy
    case '09d':
    case '09n':
      return Rain
    case '10d':
      return RainScattered
    case '10n':
      return RainScatteredNight
    case '11d':
    case '11n':
      return Thunderstorm
    case '13d':
    case '13n':
      return Snow
    case '50d':
    case '50n':
      return WindyStrong
    default:
      return Sun
  }
}

export const getWeatherIconDescriptionKey = weatherIcon => {
  switch (weatherIcon) {
    case '01d':
      return 'outdoorWeather.clearSky'
    case '01n':
      return 'outdoorWeather.clearSky'
    case '02d':
      return 'outdoorWeather.partlyCloudy'
    case '02n':
      return 'outdoorWeather.partlyCloudy'
    case '03d':
    case '03n':
      return 'outdoorWeather.cloud'
    case '04d':
    case '04n':
      return 'outdoorWeather.cloudy'
    case '09d':
    case '09n':
      return 'outdoorWeather.rain'
    case '10d':
      return 'outdoorWeather.rainScattered'
    case '10n':
      return 'outdoorWeather.rainScattered'
    case '11d':
    case '11n':
      return 'outdoorWeather.thunderstorm'
    case '13d':
    case '13n':
      return 'outdoorWeather.snow'
    case '50d':
    case '50n':
      return 'outdoorWeather.windyStrong'
    default:
      return 'outdoorWeather.clearSky'
  }
}
